import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-accordion-button',
  templateUrl: './accordion-button.component.html'
})
export class AccordionButtonComponent implements OnInit {
  @Output() clickEmitter = new EventEmitter();
  @Input() isOpen = true;

  emitClick() {
    this.clickEmitter.emit();
  }

  ngOnInit(): void {
  }
}
